import React from 'react';
import styles from './styles.module.scss';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

const AcessoIndisponivel: React.FC = () => (
  <div>
    <Header />
    <div className={styles.container}>
    <div className={styles.wrapper}>
      <img
        src='images-capa/global/acesso-indisponivel.svg'
        title='Acesso indisponível temporariamente'
        alt='homem sentado em um assento de avião com um notebook sobre o colo de um ícone de alerta vermelho'
      />
      <div>
        <h1>Acesso à plataforma indisponível!</h1>
        <p>
          Seu acesso à plataforma está temporariamente indisponível. Seu cadastro foi reprovado ou está inativo.
        </p>
      </div>
    </div>

    <div className={styles.textCenter}>
      <h2>Quer regularizar seu acesso?</h2>
      <p>Entre em contato com nossa analista de sucesso do cliente.</p>
    </div>

    <div className={styles.containerCards}>
      <div className={styles.card}>
        <div className={styles.titleCard}>
          <img
            src='images-capa/global/email.svg'
            title='Email'
            alt='ícone de email'
            width={32}
            height={32}
          />
          <h3>E-mail</h3>
        </div>
        <a href='mailto:karine.santos@amopromo.com' className={styles.infoLink}>
          <span>karine.santos@amopromo.com</span>
          <img 
            src="images-capa/global/arrow-right.svg" 
            title="Enviar email" 
            alt="ícone de seta para direita branca com fundo roxo" 
            width={32}
            height={32}
          />
        </a>
      </div>
      <div className={styles.card}>
        <div className={styles.titleCard}>
          <img
            src='images-capa/global/whatsapp.svg'
            title='WhatsApp'
            alt='ícone de WhatsApp'
            width={32}
            height={32}
          />
          <h3>WhatsApp</h3>
        </div>
        <a href='https://wa.me/553184214126' className={styles.infoLink}>
          <span>+55 31 8421-4126</span>
          <img 
            src="images-capa/global/arrow-right.svg" 
            title="Enviar WhatsApp" 
            alt="ícone de seta para direita branca com fundo roxo" 
            width={32}
            height={32}
          />
        </a>
      </div>
      <div className={styles.card}>
        <div className={styles.titleCard}>
          <img
            src='images-capa/global/horario.svg'
            title='Horário de atendimento'
            alt='ícone de relógio de ponto'
            width={32}
            height={32}
          />
          <h3>Horário de atendimento</h3>
        </div>
        <p className={styles.infoText}>
          De <strong>segunda a sexta</strong>: de 8h às 17h. 
        </p>
      </div>
    </div>
    </div>
    <Footer />
  </div>
);

export default AcessoIndisponivel;